// Initializes save/unsave behavior for funding cards and single CTA.
export default function fundingSaveButtonsComponent() {
	// Updates the visual state for one Save button.
	const updateButtonState = (button, saved) => {
		button.classList.toggle('is-saved', saved);
		button.setAttribute('aria-pressed', saved ? 'true' : 'false');
		const label = button.querySelector('.save-label');
		if (label) {
			label.textContent = saved ? 'Saved' : 'Save';
		}
	};

	// Sends the AJAX toggle request for a single clicked button.
	const toggleSavedFunding = async (button) => {
		if (!(button instanceof HTMLButtonElement)) {
			return;
		}

		const postId = Number.parseInt(button.dataset.postId || '', 10);
		const ajaxUrl = button.dataset.ajaxUrl || '';
		const action = button.dataset.action || '';
		const nonce = button.dataset.nonce || '';

		if (!postId || !ajaxUrl || !action || !nonce) {
			return;
		}

		button.disabled = true;

		try {
			const body = new URLSearchParams({
				action,
				nonce,
				post_id: String(postId),
			});
			const response = await fetch(ajaxUrl, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				},
				body: body.toString(),
			});

			if (!response.ok) {
				return;
			}

			const payload = await response.json();
			if (!payload?.success) {
				return;
			}

			const saved = Boolean(payload?.data?.saved);
			updateButtonState(button, saved);
		} catch (error) {
			// Keep UI unchanged on transport errors.
		} finally {
			button.disabled = false;
		}
	};

	// Binds click handlers once (FacetWP re-renders list HTML after filtering).
	const bindSaveButtons = () => {
		document.querySelectorAll('.js-funding-save-toggle').forEach((button) => {
			if (button.dataset.saveBound === '1') {
				return;
			}

			button.dataset.saveBound = '1';
			button.addEventListener('click', () => {
				toggleSavedFunding(button);
			});
		});
	};

	bindSaveButtons();
	document.addEventListener('facetwp-loaded', bindSaveButtons);
}
